import { endsWith, trimStart } from 'lodash';

export const checkSlash = (url: string): string => {
  return `${url}${endsWith(url, '/') ? '' : '/'}`;
};

export const checkUrlStartSlash = (url: string): string => {
  return trimStart(url, '/');
};
